/**
 * @catworld/shared -- the wire & persistence contracts, whole, at the root.
 *
 * This is the only door.  The package's exports map declares "." and nothing
 * else, so a deep import (`@catworld/shared/src/happy.js`) is a resolution error
 * rather than a convention -- docs/ARCH-PLAN.md §1.1's root-imports-only
 * rule, enforced where it can actually refuse.
 *
 * One name needs a word: PROTO_VERSION is declared in constants.ts and
 * re-exported by protocol.ts (beside the messages it versions), and ES star
 * exports silently EXCLUDE any name two modules both offer.  The explicit
 * line at the bottom resolves it back to the declaration, so the package
 * root always carries it.
 */
export * from "./constants.js";
export * from "./phrases.js";
export * from "./happy.js";
export * from "./look.js";
export * from "./catrecord.js";
export * from "./protocol.js";
export { PROTO_VERSION } from "./constants.js";
export * from "./exterior.js";
export * from "./doors.js";
